import React from "react";
import { Link } from "react-router-dom";

export default function Collection(props) {
  // ((prop) => console.log(prop))(props)
  return (
    <>
      <main>
        <div className="collection_cards">
          {/* <div className="collection_card">
          
            <div className="collection_card__image-wrapper">
              <img
                className="collection_card__image"
                src="https://picsum.photos/500/500?random=1"
                alt="Deserts"
                width="280"
                height="420"
              />
            </div>
            <Link to={"/animal_detail"}>
            <div className="collection_card__content">
              <h5 className="collection_card__category">Category</h5>
              <h2 className="collection_card__title">Title Goes Here</h2>
              <p className="collection_card__text">
                Lorem ipsum dolor sit amet consectetur adipisicing elit nulla
                cumque. massa placerat duis ultricies lacus sed turpis tincidunt
                id aliquet risus feugiat in ante metus dictum at tempor commodo
                ullamcorper.
              </p>
            </div>
            </Link>
          </div> */}


        {props.data.map((item) => (
          <div className="collection_card" key={item.id}>
            <div className="collection_card__image-wrapper">
              <img
                className="collection_card__image"
                src={
                  item.values.images.imageArray3[0] &&
                  item.values.images.imageArray3[0].images &&
                  item.values.images.imageArray3[0].images.regular &&
                  item.values.images.imageArray3[0].images.regular.length !== 0
                    ? item.values.images.imageArray3[0].images.regular
                    : `https://picsum.photos/500/500?random=${Math.floor(Math.random() * 1000)}`
                }
                
                
                alt={item.values.query}
                width="280"
                height="420"
              />
            </div>
            <Link to={`/animal_detail?q=${encodeURIComponent(item.values.query)}`}>
              <div className="collection_card__content">
                <h5 className="collection_card__category">{item.values.data.taxonomy.class}</h5>
                <h2 className="collection_card__title">{item.values.query}</h2>
                <p className="collection_card__text">{(item.values.data.characteristics.slogan)?(item.values.data.characteristics.slogan):(item.values.data.characteristics['estimated_population_size'])}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>


      </main>
    </>
  );
}
